<template>
  <div class="ui-user-form">
    <component
      v-for="opitonsKey in defaultOptions"
      :is="renderCmp(opitonsKey)"
      :key="`form_${opitonsKey}`"
      :label="userInfoFormMap[opitonsKey].label"
      v-model="formData[`${userInfoKeyMap[opitonsKey]}`]"
      mountElClass="user-info-wrapper"
    ></component>
  </div>
</template>

<script>
import FormItemGrade from "@/components/NfForm/FormItemGrade"
import FormItemHeader from "@/components/NfForm/FormItemHeader"
import FormItemLocation from "@/components/NfForm/FormItemLocation"
import FormItemName from "@/components/NfForm/FormItemName"
import FormItemPhone from "@/components/NfForm/FormItemPhone"
import FormItemSchool from "@/components/NfForm/FormItemSchool"
import FormItemTeacher from "@/components/NfForm/FormItemTeacher"
import { USER_INFO_FORM_MAP, USER_INFO_KEY_MAP } from "@/dictionary"
import { mapGetters, mapMutations } from "vuex"

export default {
  name: "uiUserForm",
  data() {
    return {
      formData: {}
    }
  },
  methods: {
    ...mapMutations({
      setUserInfo: "userInfo/setUserInfo"
    }),
    renderCmp(key) {
      let result = null
      switch (key) {
        case "HEAD":
          result = FormItemHeader
          break
        case "ADVISOR":
          result = FormItemTeacher
          break
        case "ADVISOR_PHONE":
          result = FormItemPhone
          break
        case "NAME":
          result = FormItemName
          break
        case "SCHOOL":
          result = FormItemSchool
          break
        case "AREA":
          result = FormItemLocation
          break
        case "GRADE":
          result = FormItemGrade
          break
      }
      return result
    }
  },
  components: {
    FormItemGrade,
    FormItemHeader,
    FormItemLocation,
    FormItemName,
    FormItemPhone,
    FormItemSchool,
    FormItemTeacher
  },
  computed: {
    ...mapGetters({
      defaultOptions: "activityInfo/defaultOptions",
      userInfo: "userInfo/userInfo",
      selectSchoolInfo: "userInfo/selectSchoolInfo"
    }),
    userInfoFormMap() {
      return USER_INFO_FORM_MAP
    },
    userInfoKeyMap() {
      return USER_INFO_KEY_MAP
    }
  },
  watch: {
    selectSchoolInfo(newVal) {
      this.formData = Object.assign({}, this.formData, {
        school: {
          schoolId: newVal.id,
          schoolName: newVal.name
        }
      })
    }
  },
  created() {
    this.formData = Object.assign({}, this.userInfo)
  }
}
</script>

<style lang="scss" scoped>
.ui-user-form {
  width: 100%;
  padding-left: 0.4rem;
}
</style>
